import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewSubmissionRedirectorComponent } from './customer-review-submission-redirector.component';

runClientComponent({ CustomerReviewSubmissionRedirectorComponent });
